<template>
    <el-table v-if="classrooms" :data="classrooms" max-height="750">
        <el-table-column
            min-width="130"
            sortable
            label="Name"
            property="name"
        ></el-table-column>
        <el-table-column
            min-width="100"
            label="Teacher PIN"
            property="admin_pin"
        ></el-table-column>
        <el-table-column
            sortable
            min-width="100"
            label="Students"
            property="students_amount"
        ></el-table-column>
        <el-table-column
            sortable
            min-width="100"
            label="Language"
            property="language"
        ></el-table-column>
        <el-table-column
            min-width="60"
        >
            <div slot-scope="{row, $index  }" class="text-right table-actions">
                <el-tooltip
                    content="View"
                    effect="light"
                    :open-delay="300"
                    placement="top"
                >
                    <router-link :to="'/school/classroom/' + row.id">
                        <base-button type="info" size="sm" class="right">
                            View
                        </base-button>
                    </router-link>
                </el-tooltip>
            </div>
        </el-table-column>
    </el-table>
</template>
<script>
    export default {
        name: 'classroom-table',
        props: ['classrooms'],
    }
</script>
